import { render, staticRenderFns } from "./add-characteristics.vue?vue&type=template&id=e9c3f056"
import script from "./add-characteristics.vue?vue&type=script&lang=js"
export * from "./add-characteristics.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports